import mixpanel, { Mixpanel } from "mixpanel-browser";
import logger from "../../lib/logger";

const token = process.env.REACT_APP_MIXPANEL_TOKEN;

/**
 * Project token for events sent straight to Mixpanel, the Segment removal
 * dual-send. Kept apart from the session replay token so the direct copy can
 * go to the Mixpanel test project while Segment still feeds the real one.
 */
const directToken = process.env.REACT_APP_MIXPANEL_DIRECT_TOKEN;
const DIRECT_INSTANCE = "direct";

let direct: Mixpanel | undefined;

export function initMixpanel(): void {
  if (token) {
    try {
      mixpanel.init(token, {
        record_sessions_percent: Number(process.env.REACT_APP_MIXPANEL_REPLAY_PERCENT) || 0,
        record_idle_timeout_ms: 1800000,
        track_pageview: false,
        autocapture: false,
      });
    } catch (error) {
      logger.error("Failed to initialize Mixpanel", { error });
    }
  }

  if (directToken) {
    try {
      direct = mixpanel.init(
        directToken,
        { track_pageview: false, autocapture: false, record_sessions_percent: 0 },
        DIRECT_INSTANCE,
      );
    } catch (error) {
      logger.error("Failed to initialize direct Mixpanel", { error });
    }
  }
}

export function identifyMixpanelUser(
  accountId: string,
  userId: string,
  properties?: Record<string, unknown>,
): void {
  // Same distinct_id the backend direct sends use. No set_group here: it would
  // register groupId as an array super property on every event, while events
  // already carry groupId as a string and the backend owns the profile.
  try {
    direct?.identify(`${userId}`);
  } catch (error) {
    logger.error("Failed to identify direct Mixpanel user", { error });
  }

  if (!token) return;

  try {
    mixpanel.identify(`${userId}`);
    mixpanel.set_group("groupId", accountId);
    mixpanel.people.set({
      accountId,
      userId,
      ...properties,
    });
  } catch (error) {
    logger.error("Failed to identify Mixpanel user", { error });
  }
}

/** Sends an event to Mixpanel directly; a no-op until the direct token is set. */
export function trackDirect(event: string, properties?: Record<string, unknown>): void {
  if (!direct) return;

  try {
    direct.track(event, properties);
  } catch (error) {
    logger.error("Failed to track Mixpanel event", { event, error });
  }
}
